/**
 * 差异
 */
import React from 'react';

import styles from './index.module.scss';

interface IProps {
  preValue: string | number;
  currentValue: string | number;
}

const Index: React.FC<IProps> = (props) => {
  const { preValue, currentValue } = props;
  if (preValue === currentValue) {
    return <div>{preValue}</div>;
  }
  return (
    <div className={styles.diffContent}>
      <span>{preValue}</span>
      <span className={styles.joinSymbol}>→</span>
      <span className={styles.currentValue}>{currentValue}</span>
    </div>
  );
};

export default Index;
